import { ShieldCheck } from 'lucide-react';
import ReglasDeAutorizacion from '../accesos/ReglasDeAutorizacion';

/* =====================================================================
   Las pantallas del carril `accesos` que cuelgan del enganche · EX-5
   =====================================================================
   «Reglas de autorización» (1 de octubre de 2026). Se engancha aquí y no
   en `ui/modulos.jsx`, que es el caliente: el menú la monta sola.

   EN «Control», JUNTO A «Reglas para todas las empresas del grupo», que
   es donde se buscan las reglas desde la Fase E3 de `escala`: las dos se
   consultan seguidas. «Control» cae en el módulo «Administración» del
   menú (`experiencia/menu.js`, MODULO_DE_GRUPO).

   POR PERMISO Y NO POR RANGO: la lista y el cambio piden
   `autorizaciones.reglas` en el servidor, y ese permiso se concede a una
   persona sin subirla de puesto. `min: 'ADMIN'` es el respaldo para un
   token viejo sin la lista de permisos, igual que en el resto del menú.

   Y SE ABRE TAMBIÉN DESDE DENTRO: «Firmas pendientes» y «Reglas para
   todas las empresas del grupo» llevan un botón con `irA` a este `id`.
   ===================================================================== */
export default {
  orden: 60,
  grupos: [{
    grupo: 'Control',
    items: [
      {
        id: 'accesos-reglas-de-autorizacion',
        etiqueta: 'Reglas de autorización',
        icono: ShieldCheck,
        permiso: 'autorizaciones.reglas',
        min: 'ADMIN',
        soloEmpresa: true,
        Comp: ReglasDeAutorizacion,
      },
    ],
  }],
};
